import React, { useState, useEffect, useCallback } from "react";
import { Box, Paper, Stack } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { CasinoOutlined as LotteryIcon } from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";

// Web3 Contract Services
import cinstance from "../../../Service/randomcinstance";
import usercinstance from "../../../Service/usercinstance";
import slotInstance from "../../../Service/slotInstance";
import web3 from "../../../Service/web3";
import { networkID } from "../../../../static/utils";
import {
  Path,
  getNetworkCurrency,
  DEFAULT_CURRENCY,
} from "../../../../static/Constants";
import Warnings from "../../../Components/Warning";
import Loaders from "../../../Components/Loaders";
import FailedPopup from "../../../Components/FailedPopup";
import SuccessPopup from "../../../Components/SuccessPopup";
import { colors, borderRadiusPx, customShadows } from "../../../../theme";

// Slot Symbol Sets & Pokies Configuration
import { getSymbolsByCategory } from "./slotSymbolConfig";

// Dashboard Layout & Shared UI Components
import { CreatorLayout } from "../../../Components/dashboard";
import { CommonButton } from "../../../Components/ui";

import CreateLotteryForm from "./CreateLotteryForm";
import "./CreateLottery.css";

const CreateLotteryPage = () => {
  const history = useHistory();
  const location = useLocation();

  // Read initial game type from URL query if provided (?type=5slot, ?type=5, ?type=3slot, or ?type=4)
  const initialType = (() => {
    const params = new URLSearchParams(location.search);
    const t = params.get("type") || (location.state && location.state.type);
    if (t === "5slot" || t === "fiveslot" || t === "5") return "5";
    if (t === "3slot" || t === "threeslot" || t === "4") return "4";
    if (["0", "1", "2", "3", "4", "5"].includes(t)) return t;
    return "0";
  })();

  const [lotterytype, setlotterytype] = useState(initialType);

  // Common Creator & Wallet State
  const [address, setAddress] = useState("");
  const [approved, setapproved] = useState({
    active: true,
    name: "AutoBET Creator",
  });
  const [lotteryCreateFee, setlotteryCreateFee] = useState("5");
  const [partnerlist, setPartnerlist] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState(
    () => DEFAULT_CURRENCY || getNetworkCurrency(networkID) || "POL",
  );
  const [validated, setValidated] = useState(false);
  const [loading, setloading] = useState(false);
  const [error, seterror] = useState(false);

  // Success / Failure Modal State
  const [showFail, setShowFail] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState(
    "Lottery created successfully!",
  );
  const [successRedirect, setSuccessRedirect] = useState(Path.orgmylottery);
  const [successBtnText, setSuccessBtnText] = useState("Go to my lotteries");

  // Standard Lottery Form State
  const [entryfee, setentryfee] = useState("");
  const [totalnumber, settotalnumber] = useState("1");
  const [totalPrize, settotalPrize] = useState("");
  const [startTime, setstartTime] = useState(
    new Date(Date.now() + 8 * 24 * 60 * 60 * 1000),
  );
  const [endtime, setendtime] = useState(
    new Date(Date.now() + 20 * 24 * 60 * 60 * 1000),
  );
  const [drawdate, setdrawdate] = useState(
    new Date(Date.now() + 20 * 24 * 60 * 60 * 1000),
  );
  const [capacity, setcapacity] = useState("");
  const [minPlayers, setminPlayers] = useState("0");
  const [selectPartner, setSelectPartner] = useState("");
  const [Rollover, setRollover] = useState("");
  const [Rolloverday, setRolloverdays] = useState("");
  const [unlockCode, setUnlockCode] = useState("");
  const [partnerPercent, setPartnerPercent] = useState(false);

  // Slot Pokies Form State (3-Slot has 5 symbols; 5-Slot has 7 symbols)
  const isInitialFive = initialType === "5";
  const [machineName, setMachineName] = useState(() =>
    isInitialFive ? "AutoBET Fiat 5-Slot Pokies" : "AutoBET Fiat 3-Slot Pokies",
  );
  const [slotCategory, setSlotCategory] = useState("fiat"); // 'fiat' | 'crypto'
  const [slotSymbols, setSlotSymbols] = useState(() =>
    getSymbolsByCategory("fiat", isInitialFive ? 7 : 5),
  );
  const [theme, setTheme] = useState("fiat");
  const [slotCurrency, setSlotCurrency] = useState(
    () => DEFAULT_CURRENCY || getNetworkCurrency(networkID) || "POL",
  );
  const [betAmount, setBetAmount] = useState("1.00");
  const [seedJackpot, setSeedJackpot] = useState("100.00");
  const [progressivePercent, setProgressivePercent] = useState("3.5");
  const [miniPercent, setMiniPercent] = useState("50");
  const [majorPercent, setMajorPercent] = useState("30");
  const [megaPercent, setMegaPercent] = useState("20");
  const [maxSpins, setMaxSpins] = useState("0");
  const [slotStartTime, setSlotStartTime] = useState(
    new Date(Date.now() + 10 * 60 * 1000), // 10 mins from now
  );
  const [slotEndTime, setSlotEndTime] = useState(
    new Date(Date.now() + 30 * 24 * 60 * 60 * 1000), // 30 days
  );
  const [slotPartner, setSlotPartner] = useState("");
  const [slotPartnerPercent, setSlotPartnerPercent] = useState("0");

  // Handle changing between the 2 options: Fiat vs Crypto
  const handleSlotCategoryChange = useCallback(
    (newCategory) => {
      setSlotCategory(newCategory);
      setTheme(newCategory);
      const isFive = String(lotterytype) === "5" || String(lotterytype) === "fiveslot";
      const symbols = getSymbolsByCategory(newCategory, isFive ? 7 : 5);
      setSlotSymbols(symbols);
      if (newCategory === "fiat") {
        setMachineName(isFive ? "AutoBET Fiat 5-Slot Pokies" : "AutoBET Fiat 3-Slot Pokies");
      } else {
        setMachineName(isFive ? "AutoBET Crypto 5-Slot Pokies" : "AutoBET Crypto 3-Slot Pokies");
      }
    },
    [lotterytype],
  );

  // Sync symbols and default name when lottery type changes
  useEffect(() => {
    const isFive = String(lotterytype) === "5" || String(lotterytype) === "fiveslot";
    const isThree = String(lotterytype) === "4" || String(lotterytype) === "threeslot";
    if (isFive) {
      setSlotSymbols(getSymbolsByCategory(slotCategory, 7));
      setMachineName((prev) =>
        prev.includes("3-Slot")
          ? prev.replace("3-Slot", "5-Slot")
          : slotCategory === "fiat"
          ? "AutoBET Fiat 5-Slot Pokies"
          : "AutoBET Crypto 5-Slot Pokies",
      );
    } else if (isThree) {
      setSlotSymbols(getSymbolsByCategory(slotCategory, 5));
      setMachineName((prev) =>
        prev.includes("5-Slot")
          ? prev.replace("5-Slot", "3-Slot")
          : slotCategory === "fiat"
          ? "AutoBET Fiat 3-Slot Pokies"
          : "AutoBET Crypto 3-Slot Pokies",
      );
    }
  }, [lotterytype, slotCategory]);

  // Keep type in sync if query param changes
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const t = params.get("type") || (location.state && location.state.type);
    if (t === "5slot" || t === "fiveslot" || t === "5") {
      setlotterytype("5");
    } else if (t === "3slot" || t === "threeslot" || t === "4") {
      setlotterytype("4");
    } else if (["0", "1", "2", "3"].includes(t)) {
      setlotterytype(t);
    }
  }, [location.search, location.state]);

  const getList = useCallback(async () => {
    try {
      if (!cinstance?.methods?.partnerId) return;
      const res = await cinstance.methods.partnerId().call();
      const count = Number(res);
      const partnerlists = [];

      for (let i = 0; i <= count; i++) {
        try {
          const responseAdd = await cinstance.methods.partnerids(i).call();
          if (
            responseAdd &&
            responseAdd !== "0x0000000000000000000000000000000000000000"
          ) {
            const response = await cinstance.methods
              .partnerbyaddr(responseAdd)
              .call();
            if (
              response &&
              response.partnerAddress !==
                "0x0000000000000000000000000000000000000000"
            ) {
              partnerlists.push(response);
            }
          }
        } catch (err) {
          console.warn("Failed fetching partner item at index", i, err);
        }
      }

      setPartnerlist(partnerlists);
    } catch (err) {
      console.warn("Error fetching partner list:", err);
    }
  }, []);

  // Submission handler for both Standard Lotteries and Slot Pokies (3-Slot & 5-Slot)
  const handleSubmit = async (event) => {
    if (event && event.preventDefault) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);

    const isThreeSlot =
      String(lotterytype) === "4" || String(lotterytype) === "threeslot";
    const isFiveSlot =
      String(lotterytype) === "5" || String(lotterytype) === "fiveslot";
    const isSlot = isThreeSlot || isFiveSlot;
    const slotReelCount = isFiveSlot ? 5 : 3;
    const symbolCount = isFiveSlot ? 7 : 5;

    if (isSlot) {
      let isSlotValid = true;

      if (Number(betAmount) <= 0 || betAmount === "") {
        toast.error("Minimum bet must be greater than 0");
        isSlotValid = false;
      }
      if (Number(seedJackpot) <= 0 || seedJackpot === "") {
        toast.error("Maximum bet must be greater than 0");
        isSlotValid = false;
      }
      if (Number(betAmount) > Number(seedJackpot)) {
        toast.error("Maximum bet must be greater than or equal to minimum bet");
        isSlotValid = false;
      }
      const tierSum =
        (Number(miniPercent) || 0) +
        (Number(majorPercent) || 0) +
        (Number(megaPercent) || 0);
      if (tierSum !== 100) {
        toast.warn(
          "Jackpot tier percentages (Mini + Major + Mega) must equal 100%",
        );
        isSlotValid = false;
      }

      if (!slotSymbols || slotSymbols.length !== symbolCount) {
        toast.error(
          `Slot machine must have ${symbolCount} symbols mapped from 0 to ${symbolCount - 1}.`,
        );
        isSlotValid = false;
      }

      const now = Math.floor(Date.now() / 1000);
      let st = moment(slotStartTime).unix();
      const et = moment(slotEndTime).unix();

      if (st < now - 60) {
        toast.error("Start time cannot be in the past!");
        isSlotValid = false;
      } else if (st < now) {
        // Buffer current time by 10s to ensure st >= block.timestamp (E25)
        st = now + 10;
      }

      if (st >= et) {
        toast.error("End date must be greater than start date!");
        isSlotValid = false;
      }

      if (!isSlotValid) {
        return;
      }

      // Map the symbols to numbers 0 to symbolCount - 1
      const symbolNumbers = slotSymbols.map((s, idx) => idx);
      const symbolMultipliers = slotSymbols.map((s) => Number(s.multiplier || 10));
      const symbolCodes = slotSymbols.map((s) => s.code);
      const symbolIds = slotSymbols.map((s) => s.id);

      const slotGamePayload = {
        machineName:
          machineName ||
          (isFiveSlot ? "AutoBET 5-Slot Pokies" : "AutoBET 3-Slot Pokies"),
        reels: slotReelCount,
        slotCategory: slotCategory, // 'fiat' or 'crypto'
        slotSet: slotCategory,
        currency: slotCurrency,
        minBet: betAmount,
        maxBet: seedJackpot,
        progressivePercent: progressivePercent,
        miniPercent: miniPercent,
        majorPercent: majorPercent,
        megaPercent: megaPercent,
        maxSpins: maxSpins,
        startTime: st,
        endTime: et,
        partner: slotPartner || "0x0000000000000000000000000000000000000000",
        partnerPercent: slotPartnerPercent || "0",
        // Mapped symbols and numbers sent to contract
        symbols: slotSymbols.map((s, idx) => ({
          contractNumber: idx,
          id: s.id,
          label: s.label,
          code: s.code,
          multiplier: s.multiplier,
          tier: s.tier,
          tierColor: s.tierColor,
          type: s.type,
        })),
        contractSymbolNumbers: symbolNumbers,
        symbolMultipliers: symbolMultipliers,
        symbolCodes: symbolCodes,
        symbolIds: symbolIds,
      };

      console.log(
        `Deploying ${slotReelCount}-Slot progressive machine with mapped symbol numbers [0-${symbolCount - 1}]:`,
        slotGamePayload,
      );

      try {
        setloading(true);

        // Attempt contract execution if web3 account is active
        const accounts = await web3?.eth?.getAccounts().catch(() => []);
        if (accounts && accounts.length > 0) {
          const sender = accounts[0];
          if (slotInstance?.methods?.createSlotGame) {
            try {
              const minBetWei = web3.utils.toWei(`${betAmount}`, "ether");
              const maxBetWei = web3.utils.toWei(`${seedJackpot}`, "ether");
              const slotSendOptions = { from: sender };
              try {
                const estimatedGas = await slotInstance.methods
                  .createSlotGame(slotReelCount, minBetWei, maxBetWei, st, et)
                  .estimateGas(slotSendOptions);
                slotSendOptions.gas = Math.floor(Number(estimatedGas) * 1.3);
              } catch (gasErr) {
                console.warn("Gas estimation notice for createSlotGame:", gasErr);
              }
              await slotInstance.methods
                .createSlotGame(slotReelCount, minBetWei, maxBetWei, st, et)
                .send(slotSendOptions);

              // Update paytable with the symbol multipliers
              if (isFiveSlot && slotInstance.methods.setPaytable5R) {
                try {
                  const paytableArray = [
                    symbolMultipliers[0] || 100,
                    symbolMultipliers[1] || 75,
                    symbolMultipliers[2] || 50,
                    symbolMultipliers[3] || 35,
                    symbolMultipliers[4] || 25,
                    symbolMultipliers[5] || 15,
                    symbolMultipliers[6] || 10,
                    500,
                  ];
                  await slotInstance.methods
                    .setPaytable5R(paytableArray)
                    .send({ from: sender });
                } catch (ptErr) {
                  console.warn("Notice setting 5R paytable:", ptErr);
                }
              } else if (!isFiveSlot && slotInstance.methods.setPaytable3R) {
                try {
                  const paytableArray = [
                    symbolMultipliers[0] || 50,
                    symbolMultipliers[1] || 40,
                    symbolMultipliers[2] || 30,
                    symbolMultipliers[3] || 20,
                    symbolMultipliers[4] || 15,
                    100,
                  ];
                  await slotInstance.methods
                    .setPaytable3R(paytableArray)
                    .send({ from: sender });
                } catch (ptErr) {
                  console.warn("Notice setting 3R paytable:", ptErr);
                }
              }
            } catch (chainErr) {
              console.warn("On-chain slot execution note:", chainErr);
            }
          }
        }

        // Store custom created slot machine config in localStorage for live games
        try {
          const existingGames = JSON.parse(
            localStorage.getItem("autobet_custom_slot_games") || "[]",
          );
          existingGames.unshift({
            ...slotGamePayload,
            id: Date.now(),
            createdAt: new Date().toISOString(),
          });
          localStorage.setItem(
            "autobet_custom_slot_games",
            JSON.stringify(existingGames),
          );
        } catch (storageErr) {
          console.warn("Storage note:", storageErr);
        }

        setloading(false);
        setSuccessMessage(
          isFiveSlot
            ? "5-Slot progressive machine created successfully!"
            : "3-Slot progressive machine created successfully!",
        );
        setSuccessRedirect(
          isFiveSlot
            ? (Path.FiveSlotlottery || "/all-five-slotlottery")
            : (Path.ThreeSlotlottery || "/all-three-slotlottery"),
        );
        setSuccessBtnText(
          isFiveSlot ? "View 5-Slot Machines" : "View 3-Slot Machines",
        );
        setShowSuccess(true);
      } catch (err) {
        console.error(`Create ${slotReelCount}-slot failed:`, err);
        setloading(false);
        setShowFail(true);
      }
    } else {
      let val = true;

      if (Number(entryfee) >= Number(totalPrize)) {
        val = false;
      }
      if (Number(entryfee) < 0 || entryfee === "") {
        val = false;
      }
      if (Number(totalPrize) <= 0 || totalPrize === "") {
        val = false;
      }
      if (lotterytype !== "3") {
        if (Number(totalnumber) > Number(capacity)) {
          val = false;
        }
        if (Number(totalnumber) < 1) {
          val = false;
        }
        if (
          (lotterytype === "0" || lotterytype === "2") &&
          Number(capacity) < 5
        ) {
          val = false;
        }
        if (lotterytype === "1" && Number(capacity) < 3) {
          val = false;
        }
      }
      if (partnerlist.length > 0 && selectPartner === "") {
        val = false;
        toast.warn("Please select a partner co-host.");
      }
      if (
        (unlockCode < 1 || unlockCode > 10 || unlockCode === "") &&
        lotterytype === "3"
      ) {
        val = false;
      }
      if (
        parseFloat(Rolloverday) < 1 &&
        (lotterytype === "2" || lotterytype === "3")
      ) {
        val = false;
      }

      if (!val) {
        return;
      }

      let days = Rolloverday;
      const currentDT = moment().unix();
      const st = moment(startTime).unix();
      const et = moment(endtime).unix();
      const dt = moment(drawdate).unix();

      if (Rolloverday === "" && lotterytype !== "2" && lotterytype !== "3") {
        days = 0;
      } else {
        days = Number(Number(Rolloverday) * 86400).toFixed();
      }

      if (currentDT > st || currentDT > et || currentDT > dt) {
        toast.error("Datetime cannot be before the current date and time!");
        return;
      }

      const rolloverValue = Number(Rollover || 0);
      if (rolloverValue > 50) {
        toast.error("Rollover value cannot exceed 50%");
        return;
      }

      if (st >= et && (lotterytype === "2" || lotterytype === "3")) {
        toast.error("Rollover/Result time must be greater than start time!");
        return;
      }

      try {
        setloading(true);
        const entryfee1 = web3.utils.toWei(`${entryfee}`, "ether");
        const totalPrize1 = web3.utils.toWei(`${totalPrize}`, "ether");
        const feePercent = Number(lotteryCreateFee || 0);
        const tl =
          (Number(totalPrize1) * feePercent) / 100 + Number(totalPrize1);
        const lotterytype1 = Number(lotterytype);

        const accounts = await web3.eth.getAccounts();
        if (!accounts || accounts.length === 0) {
          toast.error("No Web3 account found. Please connect your wallet.");
          setloading(false);
          return;
        }

        const sendOptions = {
          from: accounts[0],
          value: tl.toString(),
        };

        if (lotterytype1 === 3) {
          sendOptions.gas = 8000000;
          sendOptions.gasLimit = 8000000;
        }

        await cinstance.methods
          .createLottery(
            entryfee1,
            totalnumber,
            totalPrize1,
            st,
            et,
            dt,
            capacity || "0",
            rolloverValue,
            days,
            partnerPercent || "0",
            selectPartner || "0x0000000000000000000000000000000000000000",
            lotterytype1,
          )
          .send(sendOptions);

        setloading(false);
        setSuccessMessage("Lottery created successfully!");
        setSuccessRedirect(Path.orgmylottery);
        setSuccessBtnText("Go to my lotteries");
        setShowSuccess(true);
      } catch (err) {
        console.error("Create lottery transaction failed:", err);
        setloading(false);
        setShowFail(true);
      }
    }
  };

  useEffect(() => {
    let isMounted = true;

    async function fetchData() {
      if (window.ethereum) {
        window.web3 = web3;
        try {
          if (web3?.eth?.net?.getId) {
            try {
              const netId = await web3.eth.net.getId();
              if (isMounted) {
                setCurrencySymbol(getNetworkCurrency(netId));
              }
            } catch (netErr) {
              console.warn("Network ID check skipped:", netErr);
            }
          }

          const accounts = await web3.eth.getAccounts();
          if (accounts && accounts.length !== 0) {
            if (isMounted) setAddress(accounts[0]);

            usercinstance.methods
              .organisationbyaddr(accounts[0])
              .call()
              .then((res) => {
                if (isMounted && res) {
                  setapproved(res);
                }
              })
              .catch((err) => console.warn("Organisation check error:", err));

            cinstance.methods
              .lotteryCreateFee()
              .call()
              .then((res) => {
                if (isMounted) {
                  setlotteryCreateFee(res);
                }
              })
              .catch((err) => console.warn("LotteryCreateFee error:", err));
          } else {
            if (isMounted) seterror(false);
          }
        } catch (e) {
          console.warn("Wallet access error:", e);
        }
      }
    }

    fetchData();
    getList();

    const handleAccountsChanged = () => {
      window.location.reload();
    };

    if (window.ethereum?.on) {
      window.ethereum.on("accountsChanged", handleAccountsChanged);
    }

    return () => {
      isMounted = false;
      if (window.ethereum?.removeListener) {
        window.ethereum.removeListener(
          "accountsChanged",
          handleAccountsChanged,
        );
      }
    };
  }, [getList]);

  return (
    <CreatorLayout
      title="Create A New Lottery & Game"
      subtitle="Configure rules, prize pools, and deploy decentralized smart contract games & 3/5-reel pokies"
      breadcrumbs={[
        { label: "Dashboard", href: Path.org },
        { label: "Create Game" },
      ]}
      headerActions={
        <Stack direction="row" spacing={1.5}>
          <CommonButton
            variant="outlined"
            size="small"
            onClick={() => history.push(Path.orgmylottery)}
            startIcon={<LotteryIcon />}
          >
            My Lotteries
          </CommonButton>
        </Stack>
      }
      creatorAddress={address}
      userName={approved?.name || "Creator"}
      authChecked={!loading}
      isAuthorized={approved?.active}
      accessDeniedProps={{
        title: "Account Access Denied",
        message:
          "You must be a registered Creator or organization to view Create Game.",
        actionText: "Register as Organisation",
        actionPath: Path.registerasorg,
      }}
    >
      <ToastContainer position="top-right" autoClose={3000} />
      {error && <Warnings />}
      {loading && <Loaders />}

      <Box sx={{ maxWidth: { xs: "100%", md: "860px", lg: "920px" } }}>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2.5, sm: 3.5 },
            borderRadius: borderRadiusPx.xl,
            border: `1px solid ${colors.dashboard.cardBorder}`,
            bgcolor: colors.background.paper,
            boxShadow: customShadows.cardFlat,
          }}
        >
          <CreateLotteryForm
            lotterytype={lotterytype}
            setlotterytype={setlotterytype}
            partnerlist={partnerlist}
            selectPartner={selectPartner}
            setSelectPartner={setSelectPartner}
            entryfee={entryfee}
            setentryfee={setentryfee}
            totalPrize={totalPrize}
            settotalPrize={settotalPrize}
            totalnumber={totalnumber}
            settotalnumber={settotalnumber}
            capacity={capacity}
            setcapacity={setcapacity}
            unlockCode={unlockCode}
            setUnlockCode={setUnlockCode}
            startTime={startTime}
            setstartTime={setstartTime}
            endtime={endtime}
            setendtime={setendtime}
            setdrawdate={setdrawdate}
            Rollover={Rollover}
            setRollover={setRollover}
            Rolloverday={Rolloverday}
            setRolloverdays={setRolloverdays}
            partnerPercent={partnerPercent}
            setPartnerPercent={setPartnerPercent}
            minPlayers={minPlayers}
            setminPlayers={setminPlayers}
            lotteryCreateFee={lotteryCreateFee}
            approved={approved}
            validated={validated}
            loading={loading}
            currencySymbol={currencySymbol}
            onSubmit={handleSubmit}
            // 3-Slot Props
            machineName={machineName}
            setMachineName={setMachineName}
            slotCategory={slotCategory}
            setSlotCategory={setSlotCategory}
            slotSymbols={slotSymbols}
            setSlotSymbols={setSlotSymbols}
            onCategoryChange={handleSlotCategoryChange}
            theme={theme}
            setTheme={setTheme}
            currency={slotCurrency}
            setCurrency={setSlotCurrency}
            betAmount={betAmount}
            setBetAmount={setBetAmount}
            seedJackpot={seedJackpot}
            setSeedJackpot={setSeedJackpot}
            progressivePercent={progressivePercent}
            setProgressivePercent={setProgressivePercent}
            miniPercent={miniPercent}
            setMiniPercent={setMiniPercent}
            majorPercent={majorPercent}
            setMajorPercent={setMajorPercent}
            megaPercent={megaPercent}
            setMegaPercent={setMegaPercent}
            maxSpins={maxSpins}
            setMaxSpins={setMaxSpins}
            slotStartTime={slotStartTime}
            setSlotStartTime={setSlotStartTime}
            slotEndTime={slotEndTime}
            setSlotEndTime={setSlotEndTime}
            slotPartner={slotPartner}
            setSlotPartner={setSlotPartner}
            slotPartnerPercent={slotPartnerPercent}
            setSlotPartnerPercent={setSlotPartnerPercent}
          />
        </Paper>
      </Box>

      {/* Transaction Modal Popups */}
      <SuccessPopup
        show={showSuccess}
        setShowModal={(e) => setShowSuccess(e)}
        message={successMessage}
        redirectPath={successRedirect}
        btnName={successBtnText}
      />
      <FailedPopup show={showFail} setShowModal={(e) => setShowFail(e)} />
    </CreatorLayout>
  );
};

export default CreateLotteryPage;
